import getScenarioStore from './getScenarioStore';
import DayGridScenario from '../schema/DayGridScenario';
import { CalendarEvent } from 'owa-calendar-types';
import { OwaDate } from 'owa-datetime';
import { DateRange } from 'owa-datetime-utils';

export function getSelectedDate(scenario: DayGridScenario): OwaDate | null {
    const {
        schedulingGridViewState: { selectedDate },
    } = getScenarioStore(scenario);
    if (!selectedDate) {
        return null;
    }
    return selectedDate;
}

export function getSelectedDateRange(scenario: DayGridScenario): DateRange | null {
    const {
        schedulingGridViewState: { selectedDate },
    } = getScenarioStore(scenario);
    if (!selectedDate) {
        return null;
    }
    return {
        start: selectedDate,
        end: selectedDate,
    };
}

export function shouldGrayOutItem(scenario: DayGridScenario, item: CalendarEvent): boolean {
    const highlightedId = getScenarioStore(scenario).highlightedId;
    if (!highlightedId) {
        return false;
    }

    return (
        item.ItemId.Id != highlightedId &&
        (!item.SeriesMasterItemId || item.SeriesMasterItemId.Id != highlightedId)
    );
}
